<template>
  <div class="offer-pin" @click="onPinClick">
    <!-- Pin filled -->
    <svg
      class="offer-pin__pin"
      :class="{
        'offer-pin__pin--active': saved
      }"
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="20px"
      y="0px"
      viewBox="0 0 193.826 193.826"
      style="enable-background:new 0 0 193.826 193.826;"
      xml:space="preserve"
    >
      <path d="M191.495,55.511L137.449,1.465c-1.951-1.953-5.119-1.953-7.07,0l-0.229,0.229c-3.314,3.313-5.14,7.72-5.14,12.406
        c0,3.019,0.767,5.916,2.192,8.485l-56.55,48.533c-4.328-3.868-9.852-5.985-15.703-5.985c-6.305,0-12.232,2.455-16.689,6.913
        l-0.339,0.339c-1.953,1.952-1.953,5.118,0,7.07l32.378,32.378l-31.534,31.533c-0.631,0.649-15.557,16.03-25.37,28.27
        c-9.345,11.653-11.193,13.788-11.289,13.898c-1.735,1.976-1.639,4.956,0.218,6.822c0.973,0.977,2.256,1.471,3.543,1.471
        c1.173,0,2.349-0.41,3.295-1.237c0.083-0.072,2.169-1.885,13.898-11.289c12.238-9.813,27.619-24.74,28.318-25.421l31.483-31.483
        l30.644,30.644c0.976,0.977,2.256,1.465,3.535,1.465s2.56-0.488,3.535-1.465l0.339-0.339c4.458-4.457,6.913-10.385,6.913-16.689
        c0-5.851-2.118-11.375-5.985-15.703l48.533-56.55c2.569,1.425,5.466,2.192,8.485,2.192c4.687,0,9.093-1.825,12.406-5.14l0.229-0.229
        C193.448,60.629,193.448,57.463,191.495,55.511z"/>
    </svg>

    <!-- Bandera filled -->
    <svg
      class="offer-pin__pennon"
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 38 48"
      style="enable-background:new 0 0 38 48;"
      xml:space="preserve"
    >
      <path v-if="saved" class="st0" d="M6.2,6.32H31.8V43.4l-12.82-6.78L6.2,43.4V6.32z"/>
      <path v-else class="st1" d="M7.2,7.32v34.42l11.31-6l0.47-0.25l0.47,0.25l11.35,6.01V7.32H7.2 M6.2,6.32H31.8V43.4l-12.82-6.78L6.2,43.4 V6.32z"/>
    </svg>
  </div>
</template>

<script>
export default {
    name: "OfferPin",
    
    props: {
        saved: {
            type: Boolean,
            default: false,
        }
    },

    methods: {
        onPinClick() {
            this.$emit("pin-click");
        },
    },
};
</script>

<style lang="scss" scoped>
.offer-pin {
    position: relative !important;
    top: 40px;
    left: calc(100% - 35px);
    z-index: 10;
    cursor: pointer;
    width: 30px;
    height: 0px;

    &:hover svg {
        fill: #0085E5;
    }

    &__pin {
        fill: #3badff;
        position: relative !important;
        right: 5px;
        top: -33px;
        width: 20px;
        z-index: 1;
        
        &--active {
            fill: white !important;

            &:hover {
              fill: white !important;
            }
        }
    }

    &__pennon {
        width: 40px !important;
        fill: #3badff;
        position: relative !important;
        top: -73px;
        right: 10px;
    }
}
</style>
